import React, { useMemo } from 'react'
import { ShowIfProps } from './ShowIf'

export const Conditional = ({ children }: { children: React.ReactNode }) => {
  const childrenList = useMemo(
    () => React.Children.toArray(children),
    [children],
  )

  const child = childrenList.find(
    (c) => React.isValidElement<ShowIfProps>(c) && c.props.condition,
  ) as React.ReactElement | null
  if (child) return child

  return childrenList.find(
    (c) => React.isValidElement<ShowIfProps>(c) && c.props.isDefault,
  ) as React.ReactElement | null
}
